<!------------------------------

Hide Proxy Element

------------------------------->


<div class="drag-dummy position-absolute" style="top:0; left: 0">
</div>

<!------------------------------

Page Actions

------------------------------->

<ng-container *sbPageAction>
  <button (click)="createNewFile()" *ngIf="!isEmbedded"
          class="btn btn-success">
    <sb-icon class="mr-2" icon="plus"></sb-icon>
    {{ 'lang.globals.newFile' | translate }}
  </button>
</ng-container>

<sb-comp-side-panel (showChange)="selectedMode = null; show = $event" [show]="show" [sidebarHeader]="sidebarHeader"
                    [sidebarTemplate]="compSidePanelTemplate" [width]="600">

</sb-comp-side-panel>
<ng-template #sidebarHeader>
  <div class="d-flex">
    <button (click)="selectedMode = null" *ngIf="!selectedAttachment && selectedMode"
            class="btn btn-hover-primary mr-3">
      <sb-icon class="icon-in-btn" icon="chevronLeft"></sb-icon>
    </button>
    <h4 *ngIf="selectedAttachment" [innerHTML]="selectedAttachment?.name | truncate : 30"></h4>
    <h4 *ngIf="!selectedAttachment">{{ 'lang.globals.newFile' | translate }}</h4>
  </div>
</ng-template>
<ng-template #compSidePanelTemplate>
  <app-attachment-edit (fileDeleted)="handleDeleteFile()" [selectedAttachment]="selectedAttachment"
                       [selectedMode]="selectedMode"></app-attachment-edit>
</ng-template>

<div (dragover)="moveDragElement($event)" class="row">
  <!------------------------------

  Proxy Element

  ------------------------------->

  <div *ngIf="dragging" [style.left.px]="dragItemStyle.left" [style.top.px]="dragItemStyle.top"
       class="dragging-item position-absolute tw-w-auto tw-drop-shadow" style="z-index: 9;">
    <div class="position-relative card card-border-radius">
      <div class="card-body">
        <div class="d-flex flex-column align-items-center">
          <app-file-dummy [draggedObj]="dragging" [dummySize]="'XS'"></app-file-dummy>
          <span [innerHTML]="dragging.name | truncate : 10" class="font-weight-bold mt-1"></span>
        </div>
      </div>
    </div>
  </div>

  <!------------------------------

Folder

------------------------------->

  <div *ngIf="!isEmbedded" class="col-lg-4">
    <sb-card>
      <div card-header classes="no-border">
        <sb-search-bar (searchAction)="doFolderSearch($event)"
                       [searchStr]="folderSearch"
                       [subline]="folderString"
                       headline="{{ 'lang.headlines.folder' | translate }}"
                       placeholder="{{ 'lang.globals.searchPlaceholder' | translate }}"
                       searchTooltip="{{ 'lang.globals.searchPlaceholder' | translate }}"
                       stopSearchTooltip="{{ 'lang.globals.stopSearchPlaceholder' | translate }}"></sb-search-bar>
      </div>
      <div card-header-more>
        <div class="form-check form-switch mr-3 blue">
          <label class="form-check-label" for="folderView" [ngbTooltip]="('lang.globals.folderViewMessage' |translate)">
            <input type="checkbox" role="switch" id="folderView" class="form-check-input" [(ngModel)]="folderView"
                   (ngModelChange)="toggleFolder(null)">
            {{ 'lang.globals.folderView' |translate }}
          </label>
        </div>
      </div>
      <div card-body>
        <ng-scrollbar style="height: 800px;">
          <table class="w-100" style="border-collapse: separate; border-spacing: 0 5px;">
            <tbody>
            <tr class="liSelect liSelected" style="background-color: #f1f3ff94;">
              <td (click)="toggleFolderCreation($event)" *ngIf="!folderCreationMode" colspan="100">
                <div class="d-flex align-items-center cursor-pointer w-100"
                     style="height: 33px;">
                  <sb-icon class="mr-3" icon="plus"></sb-icon>
                  {{ 'lang.globals.createFolder' | translate }}
                </div>
              </td>
              <td *ngIf="folderCreationMode" colspan="100">
                <div class="d-flex align-items-center" style="height: 33px;">
                  <input #folderInput [(ngModel)]="folderName" class="form-control mr-3"
                         placeholder="{{'lang.globals.folderName' | translate}}"
                         type="text" />
                  <button
                    (click)="createNewFolder()" (keydown.enter)="createNewFolder()" [disabled]="!folderName"
                    class="btn btn-sm btn-success mr-3">
                    <sb-icon icon="checked"></sb-icon>
                  </button>
                  <button (click)="toggleFolderCreation($event)" class="btn btn-light-danger btn-sm">
                    <sb-icon
                      icon="cancel"></sb-icon>
                  </button>
                </div>
              </td>
            </tr>
            <tr (click)="folderView? toggleFolder(null): null" (dragleave)="dragOut($event)" (dragover)="dragOver($event, -1)"
                (drop)="drop($event, null)"
                [ngClass]="{'liSelected' : !selectedFolderId, 'liHover' : folderDragoverId === -1, '*:!tw-cursor-default': !folderView}"
                class="liSelect">
              <td colspan="100">
                <sb-icon class="mr-3" icon="server"></sb-icon>
                {{ 'lang.globals.rootFolder' | translate }}
              </td>
            </tr>
            <tr (click)="folderView? toggleFolder(folder): null" (dragleave)="dragOut($event)" (dragover)="dragOver($event, folder?.id)"
                (drop)="drop($event, folder.id)"
                *ngFor="let folder of attachmentFolders"
                [ngClass]="{'liSelected' : folder.id === selectedFolderId, 'liHover' : folderDragoverId === folder.id, '*:!tw-cursor-default': !folderView}"
                class="liSelect">
              <td>
                <sb-icon class="mr-3" icon="folder"></sb-icon>
                <span [innerHTML]="folder.name | truncate : 30"></span></td>
              <td>
                <span>{{ folder.elementsCount }}</span>
              </td>
              <td>
                <span>{{ util.formatBytes(folder.folderSize) }}</span>
              </td>
              <td class="text-right">
                <sb-icon (click)="deleteFolder($event, folder)" class="red" icon="trash"></sb-icon>
              </td>
            </tr>
            </tbody>
          </table>
        </ng-scrollbar>
      </div>
    </sb-card>
  </div>
  <!------------------------------

         Attachment

   ------------------------------->
  <div [ngClass]="isEmbedded ? 'col-lg-12' : 'col-lg-8'">

    <sb-comp-uploading-element>
    </sb-comp-uploading-element>

    <sb-table-wrapper (boolChange)="boolChange($event?.id, $event?.value)" (filterChange)="requestDebounced()"
                      (optionsChange)="requestDebounced($event)" [boolToggles]="initialBooleans"
                      [forceViewSetting]="isEmbedded ? 'list' : null"
                      [itemName]="'attachments'" [itemsData]="attachments" [loading]="loading"
                      [options]="options"
                      headline="{{'lang.headlines.attachments' | translate}}">

      <div header-more>
        <button (click)="createNewFile()" *ngIf="isEmbedded"
                class="btn btn-success">
          <sb-icon class="mr-2" icon="plus"></sb-icon>
          {{ 'lang.globals.newFile' | translate }}
        </button>
      </div>

      <!------------------------------

          Table Header

    ------------------------------->
      <ng-template #thead>
        <tr>
          <th>
            {{ 'lang.headlines.folder' |translate }}
          </th>
          <th>
            Name
          </th>
          <th class="d-xxl-table-cell d-none">
            {{ 'lang.globals.modifiedAt' | translate }}
          </th>
          <th>
            <!-- Actions via Button -->
          </th>
        </tr>
      </ng-template>

      <!------------------------------

        Table Body

    ------------------------------->

      <ng-template #singleRow>
        <tr sb-comp-attachment-upload>
        </tr>
      </ng-template>
      <ng-template #tbody let-attachment>
        <tr (attachmentSelected)="selectAttachment($event)" (dragendEmitter)="dragEnd()"
            (dragstartEmitter)="dragStart($event)" [attachment]="attachment"
            sb-comp-attachment-list-entry>
        </tr>
      </ng-template>

      <!------------------------------

        Card Element

    ------------------------------->
      <!--<ng-template #singleCard>
        <div sb-comp-attachment-upload class="h-100"></div>
      </ng-template>
      -->
      <ng-template #card let-attachment>
        <sb-comp-attachment-card-entry (attachmentSelected)="selectAttachment($event)" (dragendEmitter)="dragEnd()"
                                       (dragstartEmitter)="dragStart($event)"
                                       [attachment]="attachment"></sb-comp-attachment-card-entry>
      </ng-template>
    </sb-table-wrapper>

  </div>
</div>

